<template>
	<div class="protocol">
		<!-- 协议列表 -->
		<nio-header-nav
			position="fixed"
			:is-white="true"
			@back="handleBack"
			:height.sync="headerHeight"
		/>
		<div
			class="main-content"
			:style="{
				paddingTop: headerHeight + 15 + 'px',
				paddingBottom: insetBottom + 'px'
			}"
		>
			<div class="main-content-title">
				购车协议
			</div>
			<div
				class="protocol-list-block"
				v-for="(item, index) in options"
				:key="index"
				@click="view(item)"
			>
				<div class="protocol-list-block__left" v-if="item.protocol_no">
					{{ item.protocol_name }}
				</div>
				<div class="protocol-list-block__right" v-if="item.protocol_no">
					<nio-icon
						:name="'icon_arrows_right_2xs'"
						style="height:16px"
						:color="'#00BEBE;'"
						:size="16"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import { queryOrderProtocols, previewContract } from '@/model'
import util from '@/util/util'
import { supreme } from '@/supreme-core'
export default {
	name: 'orderProtocolList',
	data() {
		return {
			order_no: '',
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			options: []
		}
	},
	created() {
		queryOrderProtocols.get({ order_no: supreme.getQueryString('order_no') }).then(res => {
			const { data } = res
			if (!data || data.result_code !== 'success') {
				let error = {}
				error.message = data.debug_msg || data.display_msg || '网络错误'
				throw error
			}
			this.options = data.data
		})
	},
	methods: {
		handleBack() {
			nativeHybrid.closeSyn()
		},
		async view(item) {
			try {
				const params = {
					contractNo: item.protocol_no
				}
				const res = await previewContract.get(params)
				const { resultCode, resultData } = res.data

				if (resultCode == 'SUCCESS') {
					nativeHybrid.openURL(resultData)
				}
			} catch (error) {
				console.log(error)
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.protocol {
	font-family: 'PingFang SC';
	.main-content {
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		height: 100vh;
		&-title {
			@include headline_1(1.4, 400, false);
			color: $text_primary;
			margin-bottom: 30px;
			&__tips {
				@include subtitle_4(1.5, 400, false);
				color: $text_secondary;
			}
			&__sub {
				@include subtitle_2(1.4, 500);
				color: $text_primary;
				margin-bottom: 20px;
			}
		}
	}
	.protocol-list-block {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 20px;
		&__left {
			@include body_1(1.5, 400, false);
		}
	}
}
</style>
